import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, Grid, Card, CardContent, CardMedia, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const BlogList = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    axios.get(`${process.env.REACT_APP_API_URL}/api/articles`)
      .then(response => {
        console.log('Pobrane dane:', response.data);
        setArticles(response.data || []);
        setLoading(false);
      })
      .catch(error => {
        console.error('Błąd podczas pobierania artykułów:', error);
        setError('Nie udało się pobrać artykułów. Spróbuj ponownie później.');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Box sx={{ textAlign: 'center' }}>Ładowanie...</Box>;
  }

  if (error) {
    return <Box sx={{ textAlign: 'center' }}>{error}</Box>;
  }

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Blog
      </Typography>

      {articles.length === 0 ? (
        <Typography variant="body1">Brak artykułów do wyświetlenia.</Typography>
      ) : (
        <Grid container spacing={3}>
          {articles.map(article => (
            <Grid item xs={12} sm={6} md={4} key={article.id}>
              <Link to={`/blog/${article.slug}`} style={{ textDecoration: 'none' }}>
                <Card sx={{ cursor: 'pointer' }}>
                  <CardMedia
                    component="img"
                    height="140"
                    image={article.image}
                    alt={article.title}
                  />
                  <CardContent>
                    <Typography variant="h6">{article.title}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {article.publishedAt} | Autor: {article.author}
                    </Typography>
                    <Button size="small" sx={{ mt: 1 }}>
                      Czytaj więcej
                    </Button>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default BlogList;